module.exports = __webpack_public_path__ + "img/community.a4516a88.jpg";